<template>
  <span class="text">NOW SERVING</span>
  <br/>
  <div class="number-text">
    <span>{{ this.from }}</span><br/>
    <span> - </span><br/>
    <span>{{ this.to }}</span>
  </div>
</template>

<script>
export default {
  name: 'NumberDisplay',
  props: {
    from: Number,
    to: Number
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width:100vh;
}
.store-hours {
  font-size: 1.5vw;
  font-family: "Egoistism";
  /* font-style: italic; */
}
.text {
  font-size: 7.5vw;
  font-family: "Egoistism";
  font-style: italic;
}
.number-text {
  font-size: 22vw;
  font-family: "Egoistism";
  font-style: italic;
  line-height: 120px;
  color: #FF0000;
}
@media (min-width:768px) {
  .text {
    font-size: 2.2vw;
    font-family: "Egoistism";
    font-style: italic;
  }
  .number-text {
    font-size: 8.5vw;
    font-family: "Egoistism";
    font-style: italic;
    line-height: 125px;
    color: #FF0000;
  }
}
</style>